export const formatRank = (rank:number) : string => {

    let page = Math.ceil(rank / 40);
    let pageRank = rank % 40 === 0 ? 40 : rank % 40;

    return `${page} 페이지 ${pageRank} `

}